import { getRuntimeEnv } from "../configs/runtimeConfig";

export function getMicrosoftOAuthRedirectUri() {
  const strict =
    String(getRuntimeEnv("REACT_APP_MICROSOFT_REDIRECT_URI_STRICT") || "")
      .toLowerCase() === "true";
  const explicit = (getRuntimeEnv("REACT_APP_MICROSOFT_REDIRECT_URI") || "").trim();
  const apiHost = (getRuntimeEnv("REACT_APP_HTTPS_HOST") || "").trim();
  const apiFallback = apiHost ? apiHost.replace(/\/?$/, "/") : "";

  if (typeof window === "undefined") {
    return explicit || apiFallback;
  }

  const host = window.location.hostname;
  const isLocal =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "[::1]";

  if (strict) {
    return explicit || apiFallback;
  }

  if (isLocal) {
    return `${window.location.origin}/`;
  }

  if (explicit) {
    try {
      const explicitOrigin = new URL(explicit).origin;
      if (window.location.origin !== explicitOrigin) {
        return `${window.location.origin}/`;
      }
      return explicit;
    } catch {
      return `${window.location.origin}/`;
    }
  }

  return apiFallback || `${window.location.origin}/`;
}
